var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBox(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 44,
    viewBox: "0 0 48 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 44,
    rx: 22,
    fill: "#EAFFF3"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24 12C23.5235 12 23.0529 12.1052 22.6218 12.3081L16.2968 15.2845C14.8948 15.9443 14 17.3544 14 18.9038V26C14 26.9978 14.5762 27.9058 15.479 28.3306L22.6218 31.6919C23.0529 31.8948 23.5235 32 24 32C24.4765 32 24.9471 31.8948 25.3782 31.6919L32.521 28.3306C33.4238 27.9058 34 26.9978 34 26V18.9038C34 17.3544 33.1052 15.9443 31.7032 15.2845L25.3782 12.3081C24.9471 12.1052 24.4765 12 24 12ZM32 24.382L25 20.882V14.3405L30.8516 17.0942C31.5526 17.4241 32 18.1291 32 18.9038V24.382ZM24 22.618L31.7343 26.4852C31.7136 26.4984 31.692 26.5104 31.6694 26.521L24.5266 29.8823C24.3619 29.9598 24.1821 30 24 30C23.8179 30 23.6381 29.9598 23.4734 29.8823L16.3306 26.521C16.308 26.5104 16.2864 26.4984 16.2657 26.4852L24 22.618ZM23 20.882L16 24.382V18.9038C16 18.1291 16.4474 17.4241 17.1484 17.0942L23 14.3405V20.882Z",
    fill: "#2F945C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBox);
export default __webpack_public_path__ + "static/media/box.630c2e4e22002dca47c42c5ef49786b1.svg";
export { ForwardRef as ReactComponent };